import {slideUp, slideDown} from "./utils";

(function () {
    "use strict";

    window.stickySidebarInstance = null;

    document.querySelectorAll('video[custom-control]').forEach(video => {
        const btn = document.createElement('button');
        btn.className = 'btn-play';
        btn.innerHTML = '<i class="fi fi-br-play"></i>';
        video.parentNode.insertBefore(btn, video.nextSibling);
    });

    document.addEventListener('click', function (e) {
        const playBtn = e.target.closest('video[custom-control] + .btn-play');
        if (playBtn) {
            const video = playBtn.previousElementSibling;
            const icon = playBtn.querySelector('i');
            if (video && icon) {
                if (icon.classList.contains('fa-pause')) {
                    video.pause();
                } else {
                    video.play();
                }
                icon.classList.toggle('fa-pause');
            }
            return;
        }

        const clipboardBtn = e.target.closest('.crunchify-clipboard');
        if (clipboardBtn) {
            const copyText = document.getElementById("product-url-inpt");
            if (copyText) {
                copyText.select();
                copyText.setSelectionRange(0, 99999);
                document.execCommand("copy");
            }
            return;
        }

        const closeSidebar = e.target.closest('.shop-archive-sidebar .section-close');
        if (closeSidebar) {
            e.preventDefault();
            const sidebar = closeSidebar.closest('.shop-archive-sidebar');
            if (sidebar) sidebar.classList.remove('show');
            return;
        }

        const showFilters = e.target.closest('.shop-filters-show');
        if (showFilters) {
            e.preventDefault();
            const sidebar = document.querySelector('.shop-archive-sidebar');
            if (sidebar) sidebar.classList.add('show');
            return;
        }

        const filtersToggle = e.target.closest('.product-filters-toggle');
        if (filtersToggle) {
            e.preventDefault();
            const sidebar = document.querySelector('.product-archive-filters--popup .shop-archive-sidebar');
            if (sidebar) sidebar.classList.toggle('show');
            return;
        }

        const termParent = e.target.closest('#responsive-categories-page .terms-list .item-parent[data-parent]');
        if (termParent) {
            const targetItem = termParent.getAttribute('data-parent');
            const parentList = termParent.closest('.terms-list');
            if (parentList) parentList.style.display = 'none';

            const targetTerm = document.querySelector('#responsive-categories-page .term-item-' + targetItem);
            if (targetTerm) {
                const siblingList = targetTerm.closest('.terms-list');
                if (siblingList) {
                    if (window.jQuery) {
                        window.jQuery(siblingList).slideDown('fast');
                    } else {
                        siblingList.style.display = 'block';
                    }
                }
            }
            return;
        }

        const arrowTarget = e.target.closest('#responsive-categories-page .terms-list a .arrow[data-target]');
        if (arrowTarget) {
            e.preventDefault();
            const targetItem = arrowTarget.getAttribute('data-target');
            document.querySelectorAll('#responsive-categories-page .terms-list').forEach(list => list.style.display = 'none');
            const targetList = document.querySelector('#responsive-categories-page .child-term-' + targetItem);
            if (targetList) {
                if (window.jQuery) {
                    window.jQuery(targetList).slideDown('fast');
                } else {
                    targetList.style.display = 'block';
                }
            }
            return;
        }

        const showYwsl = e.target.closest('.show-ywsl-box');
        if (showYwsl) {
            e.preventDefault();
            const box = document.querySelector('.ywsl-box');
            if (box) {
                if (window.jQuery) {
                    window.jQuery(box).slideToggle();
                } else {
                    box.style.display = (box.style.display === 'none' || box.style.display === '') ? 'block' : 'none';
                }
            }
            return;
        }

        const widgetHeader = e.target.closest('.shop-archive-sidebar--collapsed .sidebar-widget .widget-header');
        if (widgetHeader) {
            const widget = widgetHeader.closest('.sidebar-widget');
            if (widget) {
                const isCollapsed = widget.classList.contains('collapsed');
                const targets = Array.from(widget.children).filter(child => !child.classList.contains('widget-header'));

                if (isCollapsed) {
                    widget.classList.remove('collapsed');
                    widget.classList.add('show');
                    targets.forEach(target => slideDown(target, 250, () => {
                        if (window.stickySidebarInstance) {
                            window.stickySidebarInstance.updateSticky();
                        }
                    }));
                } else {
                    let callbackCalled = false;
                    targets.forEach(target => slideUp(target, 250, () => {
                        if (!callbackCalled) {
                            widget.classList.remove('show');
                            widget.classList.add('collapsed');
                            callbackCalled = true;
                            if (window.stickySidebarInstance) {
                                window.stickySidebarInstance.updateSticky();
                            }
                        }
                    }));
                }
            }
            return;
        }
    });

    document.addEventListener("keydown", function (e) {
        if ((e.ctrlKey && e.keyCode === 75) || (e.ctrlKey && e.keyCode === 70)) {
            const searchBox = document.querySelector(".search-form-widget .search-input");
            if (searchBox) {
                e.preventDefault();
                window.scrollTo({
                    top: searchBox.getBoundingClientRect().top + window.scrollY - 60,
                    behavior: 'smooth'
                });
                searchBox.focus();
            }
        }
    });

    const initDOM = () => {
        setTimeout(function () {
            document.querySelectorAll('.carousel .carousel-item img:not(.loaded)').forEach(img => {
                const src = img.getAttribute('data-src');
                if (src) {
                    img.setAttribute('src', src);
                }
                img.classList.add('loaded');
            });
        }, 1000);

        document.querySelectorAll('#shipping_city, #billing_city').forEach(input => {
            input.classList.add('form-control');
        });

        if (window.location.hash === "#_=_") {
            if (history.replaceState) {
                history.replaceState(null, null, window.location.href.split("#")[0]);
            } else {
                window.location.hash = "";
            }
        }

        const initYithWaitlist = () => {
            const emailInput = document.querySelector("#yith-wcwtl-email");
            if (emailInput) {
                const outputCon = emailInput.closest("#yith-wcwtl-output");
                if (outputCon) {
                    const btn = outputCon.querySelector("a.button");
                    if (btn) {
                        const originalHref = btn.getAttribute("href");
                        emailInput.addEventListener("input", function () {
                            const val = emailInput.value;
                            const name = emailInput.getAttribute("name");
                            btn.setAttribute("href", originalHref + "&" + name + "=" + encodeURIComponent(val));
                        });
                    }
                }
            }
        };

        initYithWaitlist();

        if (window.jQuery) {
            window.jQuery("form.variations_form").on("show_variation", initYithWaitlist);
            window.jQuery(document).on("qv_loader_stop", initYithWaitlist);
        }

        // Collapse widgets in collapsed shop archive sidebar on load
        const sidebars = document.querySelectorAll('.shop-archive-sidebar');
        sidebars.forEach(sidebar => {
            if (sidebar && sidebar.classList.contains('shop-archive-sidebar--collapsed')) {
                const widgets = sidebar.querySelectorAll('.sidebar-widget');

                // Helper to check if a widget has an active filter
                const hasActiveFilter = (widget) => {
                    if (widget.querySelector('.chosen, .active, .current-cat, .current-cat-parent, .woocommerce-widget-layered-nav-list__item--chosen')) {
                        return true;
                    }
                    const checkedInputs = widget.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked');
                    if (checkedInputs.length > 0) {
                        return true;
                    }
                    const urlParams = new URLSearchParams(window.location.search);
                    if (urlParams.toString() !== "") {
                        if (widget.classList.contains('widget_price_filter') || widget.querySelector('.price_slider')) {
                            if (urlParams.has('min_price') || urlParams.has('max_price')) {
                                return true;
                            }
                        }
                        const inputs = widget.querySelectorAll('input, select');
                        for (let input of inputs) {
                            const name = input.getAttribute('name');
                            if (name && urlParams.has(name)) {
                                const val = urlParams.get(name);
                                if (val !== null && val !== '') {
                                    return true;
                                }
                            }
                        }
                    }
                    return false;
                };

                let firstHeaderWidget = null;
                let activeFilterFound = false;

                widgets.forEach(widget => {
                    if (widget.querySelector('.widget-header')) {
                        if (!firstHeaderWidget) {
                            firstHeaderWidget = widget;
                        }

                        if (hasActiveFilter(widget)) {
                            widget.classList.add('show');
                            activeFilterFound = true;
                        } else {
                            widget.classList.add('collapsed');
                        }
                    }
                });

                // If no active filters were found, open the first widget with a header by default
                if (!activeFilterFound && firstHeaderWidget) {
                    firstHeaderWidget.classList.remove('collapsed');
                    firstHeaderWidget.classList.add('show');
                }
            }
        });

        setTimeout(()=>{
            if (window.stickySidebarInstance) {
                window.stickySidebarInstance.updateSticky();
            }
        },2000);

        // Initialize Sticky Sidebar on shop archive sidebar if active (independent of accordion state)
        const stickySidebarEl = document.querySelector('.shop-archive-sidebar-sticky-wrapper');
        if (stickySidebarEl && typeof window.StickySidebar !== 'undefined') {
            window.stickySidebarInstance = new window.StickySidebar('.shop-archive-sidebar-sticky-wrapper', {
                topSpacing: 30,
                bottomSpacing: 30,
                minWidth: 992
            });
        }
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initDOM);
    } else {
        initDOM();
    }
})();
